const prod = 'https://ido257gg7l.execute-api.sa-east-1.amazonaws.com/production'

const dev = 'http://localhost:3001/development'

const sii = 'https://nilf6xxgaf.execute-api.sa-east-1.amazonaws.com/production'

export const API_URL = process.env.NODE_ENV === 'development' ? dev : prod
export const SII_API_URL = sii
